import script from "./custom-class-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./custom-class-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__